import React from 'react';
import { CheckIcon } from 'lucide-react';
import { BRAND, manualIncludes } from '../data/site';
import { BuyButton } from './ui/BuyButton';
export function ManualSection() {
  return <section className="w-full bg-sage-800 py-14 sm:py-20 lg:py-24" data-id="element-84" data-mp="1qzxgmvuqxjwn">
      <div className="mx-auto grid max-w-6xl items-center gap-9 px-4 sm:gap-12 sm:px-8 lg:grid-cols-[0.95fr_1.05fr] lg:gap-16" data-id="element-85" data-mp="1qxkpbs33lx6x">
        <div className="mx-auto max-w-[240px] sm:max-w-[380px] lg:max-w-none" data-id="element-86" data-mp="20pqrfun2duzu">
          <img src={BRAND.ebookMockup} alt="Mockup del Manual de Esferas Navideñas con +80 técnicas" className="w-full object-contain drop-shadow-[0_40px_60px_rgba(0,0,0,0.5)]" data-id="element-87" data-mp="20rteq6wu1a0v" />
        </div>

        <div className="text-center lg:text-left" data-id="element-88" data-mp="29o2clh55w0kw">
          <p className="flex items-center justify-center gap-2.5 text-[10px] font-semibold uppercase tracking-[0.18em] text-gold-200 sm:gap-3 sm:text-[11px] sm:tracking-overline lg:justify-start" data-id="element-89" data-mp="2ephy1ab9493t">
            <span className="h-px w-7 bg-gold-400/50" aria-hidden="true" data-id="element-90" data-mp="kafhw383e3dk" />
            El manual
          </p>
          <h2 className="mt-4 font-serif text-[1.8rem] leading-[1.12] text-cream sm:mt-5 sm:text-[2.7rem] sm:leading-[1.07] lg:text-[3.1rem]" data-id="element-91" data-mp="x6hzr60croj6">
            Todo lo que necesitas para empezar{' '}
            <span className="italic text-gold-200" data-id="element-92" data-mp="oe7r3t53vr41">desde cero</span>
          </h2>

          <p className="mt-5 text-[13px] font-medium uppercase tracking-wider text-sage-200 sm:mt-6 sm:text-[15px]" data-id="element-93" data-mp="jeutqeglz1n7">
            Dentro del manual encontrarás:
          </p>

          <ul className="mt-4 space-y-2.5 text-left sm:mt-5 sm:space-y-3" data-id="element-94" data-mp="1c2qxu48ibvu0">
            {manualIncludes.map(item => <li key={item} className="flex items-start gap-3 rounded-2xl border border-sage-700 bg-sage-900/50 px-4 py-3" data-id="element-95" data-mp="173e2ev3klgft">
                <CheckIcon className="mt-0.5 h-4 w-4 flex-none text-gold-200" aria-hidden="true" data-id="element-96" data-mp="125cmuk5crz93" />
                <span className="text-[14px] leading-snug text-sage-100 sm:text-[14.5px]" data-id="element-97" data-mp="3ru50w0zcux1u">
                  {item}
                </span>
              </li>)}
          </ul>

          <div className="mt-8 flex justify-center sm:mt-9 lg:justify-start" data-id="element-98" data-mp="3oc7ahuf7wlc0">
            <BuyButton size="lg" variant="gold" label="Quiero aprender estas técnicas" href="#oferta" className="w-full sm:w-auto" data-id="element-99" data-mp="3oa4mth1jf4ag" />
          </div>
        </div>
      </div>
    </section>;
}